/**
 * 
 * @author Jesus R. Nava Cruz
 * @company Erillam Healthcare
 * @version 1.0
 * 
 */

import axios from "axios";
import ServicePath from "@/core/ServicePath";
import {
    MainRequest
} from "@/core/request";

export default class LoginRequest extends MainRequest{

    static validateUsers(data){
        return this.postSEC(ServicePath.VALIDATE_USER, data)
    }

    static loginUser(data, token){
        return axios.post(ServicePath.LOGIN_USER, data, token)
    }
}